import { FC, Fragment, useReducer } from 'react';

import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';

import { initialValues, SlotForm } from '../slotFormDialog/form';
import { SlotFormDialog } from '../slotFormDialog/SlotFormDialog';

import { slotService } from 'v2/api/slotService';
import { handleHttpError } from 'v2/utils';

interface CreateSlotButtonProps {
  onSuccess: VoidFunction;
}

export const CreateSlotButton: FC<CreateSlotButtonProps> = ({ onSuccess }) => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);

  const { trigger, isMutating } = useSWRMutation('createSlot', slotService.createSlot, {
    onSuccess: () => {
      onSuccess();
      toast.success('New slot has been successfully created');
      setOpen();
    },
    onError: handleHttpError,
  });

  const handleSubmit = (values: SlotForm, resetForm: VoidFunction) => {
    trigger(values).then(() => resetForm());
  };

  return (
    <Fragment>
      <Button onClick={setOpen} startIcon={<Plus />} variant="contained" size="large">
        Create Slot
      </Button>

      <SlotFormDialog
        title="Create Slot"
        isOpen={isOpen}
        onClose={setOpen}
        initialValues={initialValues}
        isSubmitting={isMutating}
        onSubmit={handleSubmit}
      />
    </Fragment>
  );
};
